import classNames from "classnames";

import styles from "../NotificationDropdown.module.scss";

/** "Just now", "5m ago", "3h ago", "Yesterday", then the date. */
export const timeAgo = (iso: string, now: Date = new Date()): string => {
  const then = new Date(iso);
  const mins = Math.floor((now.getTime() - then.getTime()) / 60000);
  if (Number.isNaN(mins)) return "";
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  if (hours < 48) return "Yesterday";
  return then.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: then.getFullYear() === now.getFullYear() ? undefined : "numeric" });
};

interface NotificationListProps {
  notifications: any[];
  onOpen: (n: any) => void;
}

/** The notification rows (or the empty state), shared by the topbar bell and the page "Notifications" panel. */
const NotificationList = ({ notifications, onOpen }: NotificationListProps) =>
  notifications.length === 0 ? (
    <div className={styles.empty}>No notifications yet.</div>
  ) : (
    <>
      {notifications.map((item: any, i: number) => (
        <button
          type="button"
          onClick={() => onOpen(item)}
          className={classNames(styles.item, { [styles.unread]: !item.read })}
          key={item.id ?? i + "-noti"}
          data-testid={`notification-${item.id ?? i}`}
        >
          <span className={styles.icon} aria-hidden>
            {item.avatar ? <img src={item.avatar} alt="" /> : <i className={item.icon || "mdi mdi-bell-outline"} />}
          </span>
          <span className={styles.text}>
            <span className={styles.itemTitle}>{item?.name || item.text}</span>
            {(item?.description || item.subText) && <span className={styles.itemBody}>{item?.description || item.subText}</span>}
            {item?.createdAt && <span className={styles.time}>{timeAgo(item.createdAt)}</span>}
          </span>
          {!item.read && <span className={styles.dot} aria-label="Unread" />}
        </button>
      ))}
    </>
  );

export default NotificationList;
